import {FormControl, Select, TextField} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
	BOX_SHADOWS,
	DATA_TYPES,
	DELIMINATOR,
	FONTS,
	SECONDARY_COLOR,
} from "../../constants";
import {isNumber} from "../../helpers/DataHelpers";
import {toPercent} from "../../helpers/FormatNumber";
import Column from "../../MachineLearning/Column";
import {makePredictionsAsString} from "../../MachineLearning/predictor";
import UserPink from "../../media/avatars/1.png";
import UserBlack from "../../media/avatars/2.png";
import UserGreen from "../../media/avatars/4.svg";
import UserPurple from "../../media/avatars/5.png";
import UserTurqous from "../../media/avatars/6.png";
import User1 from "../../media/avatars/7.png";
import User2 from "../../media/avatars/8.svg";
import UserBlue from "../../media/avatars/9.svg";
import {stateType, stateTypeF} from "../../state";
import {BoxHeader} from "../Common/BoxHeader";

export const PERSONA_IMAGES = [
	UserBlue,
	UserGreen,
	UserPurple,
	UserPink,
	UserBlack,
	UserTurqous,
	User1,
	User2,
	// UserPink,

	// UserGreen,
	// UserBlue,
	// UserPurple,
	// UserTurqous,
];

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			flexDirection: "column",
			width: "70%",
			backgroundColor: "white",
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			height: "520px",
		},
		inputsContainer: {
			display: "flex",
			color: "rgba(0,0,0,0.5)",
			flexDirection: "column",
			marginLeft: "10px",
			width: "90%",
		},
		inputRows: {
			display: "grid",
			gridTemplateColumns: "22% 22% 22% 22%",
			flexDirection: "column",
			justifyContent: "center",
			marginTop: "20px",
			width: "100%",
		},
		dropdownTitle: {
			fontFamily: FONTS,
			marginLeft: "0px",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
			width: "120px",
		},
		personaIcon: {width: "90px", height: "90px"},
		personaTagConatiner: {display: "flex", flexDirection: "row"},
		pageTagContainer: {
			overflow: "auto",
			justifyContent: "space-between",
			display: "flex",
			flexDirection: "row",
			marginTop: "10px",
			marginLeft: "35px",
			width: "100%",
		},
		inputsBlockContainer: {
			width: "100%",
			justifyContent: "center",
			alignItems: "center",
			height: "250px",
			marginLeft: "-10px",
		},
		pageArrowLeft: {
			color: SECONDARY_COLOR,
			width: "20px",
			height: "20px",
			marginTop: "2px",
			transition: "0.2s",
			transform: "rotate(180deg)",
			"&:hover": {transform: "scale(1.2) rotate(180deg)"},
			cursor: "pointer",
		},
		pageArrowRight: {
			color: SECONDARY_COLOR,
			width: "20px",
			height: "20px",
			marginTop: "2px",
			transition: "0.2s",
			"&:hover": {transform: "scale(1.2)"},
			cursor: "pointer",
		},
		icon: {width: "30px", height: "30px"},
		makePredButton: {
			fontFamily: FONTS,
			fontWeight: "bold",
			width: "20%",
			height: "40px",
			marginLeft: "50px",
			marginTop: "30px",
			backgroundColor: SECONDARY_COLOR,
		},
	})
);

export function makePrediction(
	state: stateTypeF,
	predictorInputs: Object,
	models?: any[]
) {
	if (!allInputsOk(state, predictorInputs)) {
		return;
	}
	if (models === undefined) {
		models = state.saveState.savedModels;
	}
	let X = state.saveState.dataset.arrayToModelInput(
		predictorInputs,
		state.saveState.modelTraining.valueToPredict
	);
	let outVal = makePredictionsAsString(
		X,
		state.saveState.dataset,
		state.saveState.modelTraining.valueToPredict,
		models
	);
	if (outVal[0].includes(DELIMINATOR)) {
		let outSplit = outVal[0].split(DELIMINATOR);
		outVal[0] =
			outSplit[0] + " (with " + toPercent(outSplit[1]) + " probability)";
	}
	return outVal[0];
}

type personaUpdateTye = {state: stateTypeF; event: eventType};
function handlePersonaUpdate(state: stateTypeF, event: any, col: Column) {
	// Update persona value
	const colValue = String(event.target.value);
	let personas = state.saveState.personaPrediction.personas;
	let persona = personas[state.saveState.personaPrediction.personaselected];
	persona.predictorValues[col.columnName] = colValue;
	persona.predicted = makePrediction(state, persona.predictorValues);
	personas[state.saveState.personaPrediction.personaselected] = persona;

	state.saveState.personaPrediction.personas = personas;
	state.setSaveStateModified(true);
	state.setSaveState(state.saveState);
}

type inputType = {state: stateTypeF; col: Column};
function NumericInput({state, col}: inputType) {
	let persona =
		state.saveState.personaPrediction.personas[
		state.saveState.personaPrediction.personaselected
		];
	let predictorValue = persona.predictorValues[col.columnName] || "";
	function handleClick() {}

	const classes = useStyles();
	return (
		<div className={classes.inputsContainer}>
			<div style={{display: "flex", flexDirection: "row"}}>
				<div className={classes.dropdownTitle}>{col.columnName}</div>
			</div>
			<TextField
				variant="outlined"
				size="small"
				onChange={(event) => handlePersonaUpdate(state, event, col)}
				onClick={handleClick}
				value={predictorValue}
			/>
		</div>
	);
}

type eventType = React.ChangeEvent<{
	value: unknown;
	id: string;
	name: string;
}>;

function CategoricalInput({state, col}: inputType) {
	const classes = useStyles();
	let values = col.nonSparseClasses;
	let persona =
		state.saveState.personaPrediction.personas[
		state.saveState.personaPrediction.personaselected
		];
	let predictorValue = persona.predictorValues[col.columnName] || "";

	return (
		<div className={classes.inputsContainer}>
			<div className={classes.dropdownTitle}>{col.columnName}</div>
			<FormControl variant="outlined" size="small">
				<Select
					value={predictorValue}
					displayEmpty
					onChange={(event) => handlePersonaUpdate(state, event, col)}
					inputProps={{
						classes: {
							icon: classes.icon,
						},
					}}
				>
					{values.map((v) => (
						<MenuItem value={v}>{v}</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}

type paginatorType = {state: stateTypeF; nPages: number};
function Paginator({state, nPages}: paginatorType) {
	const classes = useStyles();
	function onRightClick() {
		let nextPage = Math.min(nPages, state.currentPersonaPage + 1);
		state.setCurrentPersonaPage(nextPage);
	}
	function onLeftClick() {
		let nextPage = Math.max(1, state.currentPersonaPage - 1);
		state.setCurrentPersonaPage(nextPage);
	}

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				marginRight: "100px",
			}}
		>
			<div onClick={onLeftClick}>
				<ArrowForwardIosIcon className={classes.pageArrowLeft} />
			</div>
			<div
				style={{
					marginLeft: "10px",
					marginRight: "10px",
					fontFamily: FONTS,
					color: "rgba(0,0,0,1)",
				}}
			>
				{`Page ${state.currentPersonaPage} of ${nPages}`}
			</div>
			<div onClick={onRightClick}>
				<ArrowForwardIosIcon className={classes.pageArrowRight} />
			</div>
		</div>
	);
}

type getInputBoxType = {state: stateTypeF; colName: string};
export function GetInputBox({state, colName}: getInputBoxType) {
	const col = state.saveState.dataset.getColumn(colName);
	if (col === undefined) {
		return <div></div>;
	}
	if (col.columnType === DATA_TYPES.number) {
		return <NumericInput state={state} col={col}></NumericInput>;
	} else if (col.columnType === DATA_TYPES.categorical) {
		return <CategoricalInput state={state} col={col}></CategoricalInput>;
	}
}

function PersonaTag({state}: stateType) {
	const classes = useStyles();

	if (state.saveState.personaPrediction.personas.length === 0) {
		let cols = state.saveState.dataset.columns.filter(
			(col) =>
				col.columnName !=
				state.saveState.modelTraining.valueToPredict &&
				col.columnType !== DATA_TYPES.unusable
		);
		setDefaultPersona(state, cols, state.saveState.savedModels);
		return <div></div>;
	}
	const persona =
		state.saveState.personaPrediction.personas[
		state.saveState.personaPrediction.personaselected
		];

	return (
		<div className={classes.personaTagConatiner}>
			<div>
				<img
					src={persona.avatar}
					className={classes.personaIcon}
					style={{
						marginLeft: "8px",
						marginRight: "8px",
						marginTop: "5px",
					}}
				></img>
			</div>
			<div>
				<div
					style={{
						marginLeft: "10px",
						fontFamily: FONTS,
						fontSize: "15px",
						marginBottom: "2px",
						color: "rgba(0,0,0,0.5)",
						marginTop: "3px",
					}}
				>
					Name
				</div>
				<div
					style={{
						marginLeft: "10px",
						fontFamily: FONTS,
						fontSize: "20px",
					}}
				>
					{persona.name}
				</div>
			</div>
		</div>
	);
}

function allInputsOk(state: stateTypeF, predictorInputs: Object) {
	let values = predictorInputs;
	let colStates: Map<string, boolean> = new Map();
	let allColsGood = true;
	for (let col of state.saveState.dataset.columns) {
		if (col.columnName === state.saveState.modelTraining.valueToPredict) {
			continue;
		}
		if (col.columnType == DATA_TYPES.categorical) {
			if (values[col.columnName] === undefined) {
				allColsGood = false;
				colStates.set(col.columnName, true);
			}
		} else if (col.columnType == DATA_TYPES.number) {
			let val = values[col.columnName];
			if (!isNumber(val)) {
				allColsGood = false;
				colStates.set(col.columnName, true);
			} else {
				colStates.set(col.columnName, false);
			}
		} else if (col.columnType == DATA_TYPES.unusable) {
			colStates.set(col.columnName, false);
		}
	}
	state.setPersonaErrorStates(colStates);
	return allColsGood;
}

export function getDefaultPersona(cols: Column[]) {
	let predictorInputs = {};
	for (let col of cols) {
		let val =
			col.columnType === DATA_TYPES.number
				? col.colStats.median
				: col.colStats.mostCommon;
		predictorInputs[col.columnName] = String(val);
	}
	return predictorInputs;
}

export function setDefaultPersona(
	state: stateTypeF,
	cols: Column[],
	models: any[]
) {
	let predictorInputs = getDefaultPersona(cols);

	let pred = makePrediction(state, predictorInputs, models);
	state.saveState.personaPrediction.personaselected = 0;

	state.saveState.personaPrediction.personas = [
		{
			predictorValues: predictorInputs,
			name: "My Persona",
			avatar: PERSONA_IMAGES[0],
			predicted: pred,
		},
	];
	state.setSaveState(state.saveState);
}

export function PersonaPredictionBox({state}: stateType) {
	const classes = useStyles();

	let cols = state.saveState.dataset.columns.filter(
		(c) =>
			c.columnType !== DATA_TYPES.unusable &&
			c.columnName !== state.saveState.modelTraining.valueToPredict
	);
	const inputBoxes = cols.map((c) => (
		<GetInputBox state={state} colName={c.columnName}></GetInputBox>
	));

	const chunkSize = 4;
	const chunksPerPage = 3;
	let allChunks = [];
	for (let i = 0; i < inputBoxes.length; i += chunkSize) {
		allChunks.push(inputBoxes.slice(i, i + chunkSize));
	}
	let nPages = Math.ceil(allChunks.length / chunksPerPage);
	let currentChunks = allChunks.slice(
		(state.currentPersonaPage - 1) * chunksPerPage,
		state.currentPersonaPage * chunksPerPage
	);

	return (
		<div className={classes.container}>
			<BoxHeader
				title={`Persona Input Values`}
				toolTip={
					"Enter values/attributes which define the persona to get your predicted target."
				}
				line={true}
			></BoxHeader>

			<div className={classes.pageTagContainer}>
				<PersonaTag state={state}></PersonaTag>
				<Paginator state={state} nPages={nPages}></Paginator>
			</div>
			<div className={classes.inputsBlockContainer}>
				{currentChunks.map((chunk) => (
					<div className={classes.inputRows}>
						{chunk.map((v) => (
							<div> {v}</div>
						))}
					</div>
				))}
			</div>
		</div>
	);
}
